<template>
	<v-layout row justify-center>
		<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<!-- <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn> -->
			<v-card style="position: relative;">
				<v-toolbar dense dark app flat color="secondary">
					<v-btn icon small flat @click="$emit('hide')">
						<v-icon>close</v-icon>
					</v-btn>
					<v-toolbar-title class="subheading">
						Add New Address
					</v-toolbar-title>
				</v-toolbar>
				<v-content>
					<div style="padding: 16px; margin-bottom: 75px;">
						<p v-show="subtitle != ''">{{subtitle}}</p>
						<v-form v-model="valid" class="new-address-form">
							<v-text-field label="Full Name" v-model="name" required :rules="nameRules"></v-text-field>
							<v-text-field label="Mobile Number" type="number" v-model="mobile_number" required :rules="mobileRules"></v-text-field>
							<v-text-field label="Email Address" type="email" v-model="email_address" required :rules="emailAddressRules"></v-text-field>
							<v-select :items="region_list" item-text="name" item-value="parent_id" v-model="region" label="Region" :rules="regionRules"></v-select>
							<v-select :items="province_list" item-text="name" item-value="id" v-model="province" label="Province" :rules="provinceRules"></v-select>
							<v-select :items="city_list" item-text="name" item-value="id" v-model="city" label="City" :rules="cityRules"></v-select>
							<v-select :items="barangay_list" item-text="name" item-value="id" v-model="barangay" label="Barangay" :rules="barangayRules"></v-select>
							<v-text-field label="Postal Code" v-model="postal_code" required :rules="postalRules"></v-text-field>
							<v-text-field label="Detailed Address (Unit number, house number, building, street name)" v-model="address"
							 required :rules="addressRules"></v-text-field>
							<v-switch :label="`Set as Primary Address`" v-model="primary"></v-switch>
						</v-form>
					</div>
				</v-content>
			</v-card>
			<!-- Start Bottom Actions -->
			<div class="bottom-actions--cart-address">
				<v-btn @click="submitNewAddress()" depressed block color="secondary">
						Submit
				</v-btn>
			</div>
			<!-- End Bottom Actions -->
		</v-dialog>
		<loader v-show="loading"></loader>
	</v-layout>
</template>
<script>
	export default {
		name: 'NewAddress',
		data() {
			return {
				// Rules
				nameRules: [
					v => !!v || 'Name is required',
				],
				mobileRules: [
					v => !!v || 'Mobile Number is required',
				],
				regionRules: [
					v => !!v || 'Region is required',
				],
				provinceRules: [
					v => !!v || 'Province is required',
				],
				cityRules: [
					v => !!v || 'City is required',
				],
				barangayRules: [
					v => !!v || 'Barangay is required',
				],
				postalRules: [
					v => !!v || 'Postal Code is required',
				],
				addressRules: [
					v => !!v || 'Address is required',
				],
				emailAddressRules: [
					v => !!v || 'Email Address is required',
				],
				// Defaults
				loading: false,
				dialog: false,
				valid: false,
				items: [],
				switch_address: false,
				region_list: [],
				province_list: [],
				city_list: [],
				barangay_list: [],
				// Form Fields
				name: "",
				mobile_number: "",
				region: "",
				province: "",
				city: "",
				barangay: "",
				postal_code: "",
				address: "",
				primary: false,
				region_name: "",
				province_name: "",
				city_name: "",
				barangay_name: "",
				email_address: "",
			}
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			primaryProps: false,
			subtitle: {
				type: String,
				default: ''
			},
			eventName: {
				type: String,
				default: 'reloadAddresses'
			}
		},
		mounted() {
			if (this.primaryProps) {
				this.primary = true;
			}
		},
		methods: {
			getRegions() {
				this.loading = true
				var req_data = []
				axios.get('/api/g/get-regions', req_data).then(res => {
						this.region_list = res.data.data
						this.region_list.forEach((data, key) => {
							if (data.parent_id == 6) {
								this.region_list[key].name = "Mindanao";
							} else if (data.parent_id == 2) {
								this.region_list[key].name = "Metro Manila";
							} else if (data.parent_id == 3) {
								this.region_list[key].name = "Luzon";
							} else if (data.parent_id == 4) {
								this.region_list[key].name = "CALABARZON";
							}
						});
						this.loading = false
					})
					.catch(err => {
						this.toaster('something went wrong.', 201);
					})
					.finally(() => {});
			},
			changeRegion() {
				if (this.region) {
					this.region_list.forEach((data, key) => {
						if (data.parent_id == this.region) {
							this.region_name = data.name
						}
					})
					this.loading = true
					this.province_list = []
					this.city_list = []
					this.barangay_list = []
					var req_data = []
					axios.get('/api/g/get-provinces/' + this.region, req_data).then(res => {
							this.province_list = res.data.data
							this.loading = false
						})
						.catch(err => {
							this.toaster('something went wrong.', 201);
						})
						.finally(() => {});
				}
			},
			changeProvince() {
				if (this.province) {
					this.province_list.forEach((data, key) => {
						if (data.id == this.province) {
							this.province_name = data.name
						}
					})
					this.loading = true
					this.city_list = []
					this.barangay_list = []
					var req_data = []
					axios.get('/api/g/get-cities/' + this.province, req_data).then(res => {
							this.city_list = res.data.data
							this.loading = false
						})
						.catch(err => {
							this.toaster('something went wrong.', 201);
						})
						.finally(() => {});
				}
			},
			changeCity() {
				if (this.city) {
					this.city_list.forEach((data, key) => {
						if (data.id == this.city) {
							this.city_name = data.name
						}
					})
					this.loading = true
					this.barangay_list = []
					var req_data = []
					axios.get('/api/g/get-barangay/' + this.city, req_data).then(res => {
							this.barangay_list = res.data.data
							this.loading = false
						})
						.catch(err => {
							this.toaster('something went wrong.', 201);
						})
						.finally(() => {});
				}
			},
			submitNewAddress() {
				if (this.valid) {
					var req_data = {}
					req_data.name = this.name
					req_data.mobile_number = this.mobile_number
					req_data.region = this.region_name
					req_data.province = this.province_name
					req_data.city = this.city_name
					req_data.barangay = this.barangay_name
					req_data.postal_code = this.postal_code
					req_data.address = this.address
					req_data.primary = this.primary
					req_data.email_address = this.email_address

					axios.post('/api/users-addresses', req_data)
					.then(res => 
					{
						this.clear()
						this.dialog = false
						EventBus.$emit(this.eventName, true);
					})
					.catch(err => 
					{
						Object.keys(err.response.data.errors).forEach((error) => 
						{
							err.response.data.errors[error].forEach((err) => 
							{
								this.toaster(err, 201);
							});
						});
						// this.toaster('something went wrong.', 201);
					})
					.finally(() => {});
				}
			},
			clear() {
				this.name = ""
				this.mobile_number = ""
				this.region = ""
				this.province = ""
				this.city = ""
				this.barangay = ""
				this.postal_code = ""
				this.address = ""
				this.primary = false
				this.region_name = ""
				this.province_name = ""
				this.city_name = ""
				this.barangay_name = ""
				this.email_address = ""
			}
		},
		watch: {
			show: {
				handler: function (after, before) {
					this.dialog = after
					if (after) {
						this.getRegions()
					}
				},
				deep: true,
			},
			region: {
				handler: function (after, before) {
					this.changeRegion()
				},
				deep: true,
			},
			province: {
				handler: function (after, before) {
					this.changeProvince()
				},
				deep: true,
			},
			city: {
				handler: function (after, before) {
					this.changeCity()
				},
				deep: true,
			},
			barangay: {
				handler: function (after, before) {
					this.barangay_list.forEach((data, key) => {
						if (data.id == this.barangay) {
							this.barangay_name = data.name
						}
					})
				},
				deep: true
			}
		}
	}

</script>

<style lang="scss">
	.bottom-actions--cart-address {
		background-color: #fff;
		height: 75px;
		position: fixed;
		bottom: 0;
		z-index: 4;
		display: flex;
		width: 100%;
		padding: 10px 16px;
		// border-top: 1px solid rgba(#000, .1);
		box-shadow: 0 3px 14px 2px rgba(0, 0, 0, 0.12);
		display: grid;
		grid-template-columns: 100%;
		align-items: center;
		font-size: 10px;

		.v-icon {
			font-size: 14px;
		}
	}

	.new-address-form .theme--light.v-label {
		color: rgba(0, 0, 0, 0.54);
		font-weight: 400;
	}

</style>
